const config = require('../../../../../config/main');
const baseAPI = config.app.baseAPI;
const baseUrlClient = config.app.baseUrlClient;

export const SET_ACCESSTOKEN: string = 'fetchdefault/SET_ACCESSTOKEN';

export interface IFetchDefault {
	accessToken?: string;
	requestInit: RequestInit;
	baseAPI: string;
	baseUrlClient: string; // TODO move to proper place
}

const initialState: IFetchDefault = {
	requestInit: {
		credentials: 'include',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
		},
	},
	baseAPI,
	baseUrlClient,
};

///** Reducer: FetchReducer */
export function FetchReducer(state = initialState, action?: any) {
	switch (action.type) {
		case SET_ACCESSTOKEN:
			return Object.assign({}, state, {
				accessToken: action.payload.accessToken,
				requestInit: {
					...state.requestInit,
					headers: {
						...state.requestInit.headers,
						Authorization: 'Bearer ' + action.payload.accessToken,
					},
				},
			});

		default:
			return state;
	}
}

/** Action Creator */
export function setAuthenticationData(accessToken) {
	return {
		type: SET_ACCESSTOKEN,
		payload: {
			accessToken,
		},
	};
}
